import {mainServer} from '../../../../../variables/config'

export const request_user = async (user_id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response = await mainServer.instance.get(`/user/${user_id}`)
  return response.data.data.user
}

